const capitalize = (s: string) => String(s[0]?.toLocaleUpperCase()) + s.slice(1);

export default capitalize;
